import { ExcelTransactionAccountType } from 'store/app/enums';

export interface CoaAccountRow {
  id: string;
  name: string;
  type: ExcelTransactionAccountType;
  recommended: boolean;
  custom: boolean;
  /** Provider account code (Xero / QuickBooks / Zoho). */
  code?: string;
}

export interface CoaTemplate {
  id: string;
  name: string;
  accounts: CoaAccountRow[];
  createdDate: string;
}

type RawCoaAccount = Partial<CoaAccountRow> & {
  accountId?: string;
  uuid?: string;
  accountName?: string;
  accountCode?: string;
  accountType?: string;
};

/** API rows use either `name`/`code`/`type` or `accountName`/`accountCode`/`accountType`. */
export function normalizeCoaAccountRow(
  raw: RawCoaAccount | null | undefined,
  index = 0
): CoaAccountRow {
  const source = raw ?? {};
  const name = String(source.name || source.accountName || '').trim();
  const code = String(source.code || source.accountCode || '').trim();
  const type = String(source.type || source.accountType || '').trim();
  const id = String(source.id || source.accountId || source.uuid || index).trim();

  return {
    ...source,
    id,
    name,
    code: code || undefined,
    type: type as ExcelTransactionAccountType,
    recommended: Boolean(source.recommended),
    custom: source.custom !== false,
  };
}
